/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/338-opt': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M14.5 13h-4a.499.499 0 01-.457-.297L6.175 4H1.5a.5.5 0 010-1h5c.198 0 .377.116.457.297L10.825 12H14.5a.5.5 0 010 1zM14.5 4h-5a.5.5 0 010-1h5a.5.5 0 010 1z"/>'
  }
})
